import classNames from 'classnames/bind';
import React from 'react';
import { RiDragMove2Line } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import JIHO_V2 from './aeroinsight/JI-HO_V2';
import Copter from './common/Copter';
import Rover from './common/Rover';
import VTOL from './common/VTOL';
import styles from './index.module.scss';
import USV10 from './m1/USV10';

const cx = classNames.bind(styles);

const Panel = ({ data: [robot] }) => {
  switch (robot.metadata['STICK_CONTROL_MODEL_KEY']) {
    case 'aeroinsight/JI-HO_V2':
      return <JIHO_V2 data={[robot]} />;

    case 'common/Copter':
      return <Copter data={[robot]} />;

    case 'common/Rover':
      return <Rover data={[robot]} />;

    case 'common/VTOL':
      return <VTOL data={[robot]} />;

    case 'm1/USV10':
      return <USV10 data={[robot]} />;

    default:
      return (
        <div className={cx('container')}>
          <div className={cx('wrapper')}>
            StickControl is not available for this vehicle.
            <br />
            Please contact us for assistance.
          </div>
        </div>
      );
  }
};

const Command = {};
Command.id = uuidv4();
Command.name = 'StickControl';
Command.displayMode = 'overlay';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiDragMove2Line;
Command.Panel = Panel;

export default Command;
